// Traducciones en español para la sección de suscripción
const subscribe = {
  title: "Suscríbete",
  message: "Si quieres ser el primero en enterarte de todos los nuevos contenidos, danos tu correo y te mantendremos informado. ¡Esperamos que te gusten!",
  checkbox: "He leído la <0>política de privacidad</0> y acepto las condiciones.",
  buttonSubscribe: "Suscribirse",
  buttonBack: "Volver",
  warningTitle: "Aviso",
  warningMsg: "Debes aceptar la política de privacidad y las condiciones para poder suscribirte.",
  enterEmailTitle: "Introduce tu correo",
  emailPlaceholder: "Correo electrónico",
  success: "¡Suscripción realizada correctamente!",
  error: "Error al suscribirse. Inténtalo de nuevo.",
  errorNoEmail: "Por favor, introduce tu correo electrónico."
}; 

export default subscribe; 